export default __webpack_public_path__ + "static/media/unity-bg.3b574295.png";